/**
 * @generated SignedSource<<437e446fcc2385dc67f5127c2ca67339>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VehicleBatteryWidgetV2_vehicle$data = {
  readonly activeFaults: ReadonlyArray<number> | null;
  readonly batteryStatus: {
    readonly charging: boolean | null;
    readonly percentage: number | null;
  } | null;
  readonly id: string;
  readonly isOnline: boolean | null;
  readonly isOnlineMobile: boolean | null;
  readonly vehicleId: string;
  readonly " $fragmentType": "VehicleBatteryWidgetV2_vehicle";
};
export type VehicleBatteryWidgetV2_vehicle$key = {
  readonly " $data"?: VehicleBatteryWidgetV2_vehicle$data;
  readonly " $fragmentSpreads": FragmentRefs<"VehicleBatteryWidgetV2_vehicle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VehicleBatteryWidgetV2_vehicle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOnline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOnlineMobile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vehicleId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BatteryStatus",
      "kind": "LinkedField",
      "name": "batteryStatus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "charging",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeFaults",
      "storageKey": null
    }
  ],
  "type": "Vehicle",
  "abstractKey": null
};

(node as any).hash = "bf060ed1ddeddb9a3608e09fdaa4f717";

export default node;
